import { useEffect, useState } from "react";
import { clone } from "lodash";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import { useShopContext } from "../../../../contexts/ShopContext";
import Shop from "../../../../entities/shop.entity";
import useStyles from "./styles";
import { Form } from "./components/Form";
import useShops from "../../../../hooks/data/useShops";
import StoreIcon from "../../../../components/StoreIcon";
import { useFetch, useStorage } from "../../../../hooks";
import useShopGroups from "../../../../hooks/data/useShopGroups";
import ShopGroup from "../../../../entities/shop-group.entity";

export const BasicData = (): JSX.Element => {
  const styles = useStyles();
  const navigate = useNavigate();
  const { shop: loadedShop, loading, setLoading, handleSelectShop } = useShopContext();

  const { enqueueSnackbar } = useSnackbar();
  const [shop, setShop] = useState<Shop>(loadedShop || ({} as Shop));
  const [shopGroups, setShopGroup] = useState<ShopGroup[]>([]);

  const repository = useShops();
  const repositoryShopGroups = useShopGroups();

  const storage = useStorage();
  const [fileToUpload, setFileToUpload] = useState<File | null>();

  const { data: shopGroupsList, loading: shopGroupsLoading } = useFetch(repositoryShopGroups.fetchAll);

  useEffect(() => {
    setShopGroup(shopGroupsList ?? []);
    setLoading(shopGroupsLoading);
  }, [shopGroupsList, shopGroupsLoading, setLoading]);

  useEffect(() => {
    setShop(clone(loadedShop || ({} as Shop)));
  }, [loadedShop]);

  const handleFetchShopImage = async (id: string): Promise<string | null | undefined> => {
    if (fileToUpload === undefined) {
      return shop.imageUrl;
    }

    if (!fileToUpload) {
      return null;
    }

    const extension = fileToUpload.name.split('.').pop();
    const avatarUrl = await storage.upload(`/shop/${id}.${extension}`, fileToUpload);
    return avatarUrl;
  };

  const handleCreate = async (value: Shop) => {
    const image = await handleFetchShopImage(shop.id);
    const result = await repository.create({ ...value, imageUrl: image });
    navigate(`/shops/${result.id}`);
  };

  const handleUpdate = async (value: Shop) => {
    await repository.update({
      ...value,
      imageUrl: await handleFetchShopImage(shop.id)
    });
    handleSelectShop(value);
  };

  const handleUpload = (file: File | null) => {
    setFileToUpload(file);
  };

  const handleSubmit = async (value: Shop) => {
    try {
      if ('id' in value) {
        await handleUpdate(value);
      } else {
        await handleCreate(value);
      }

      enqueueSnackbar('Loja salva com sucesso', { variant: 'success' });
    } catch (err) {
      enqueueSnackbar('Não foi possível salvar a loja', { variant: 'error' });
    }
  };

  if (loading) {
    return <></>;
  }

  return (
    <div className={styles.container}>
      <StoreIcon title="Dados básicos" />
      <Form handleUpload={handleUpload} fileToUpload={fileToUpload} shop={shop} shopGroups={shopGroups} onSubmit={handleSubmit} />
    </div>
  );
};

export default BasicData;

